"use strict";

exports.__esModule = true;
exports.getHasBottomGutter = exports.getHasAppPadding = exports.getMaxWidth = exports.WidgetWrapper = void 0;

var tslib_1 = require("tslib");

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var getProp_1 = tslib_1.__importDefault(require("sportnet-utilities/lib/getProp"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var Actsection_1 = tslib_1.__importDefault(require("./Actsection"));

var ArticleList_1 = tslib_1.__importDefault(require("./ArticleList"));

var Banners_1 = tslib_1.__importDefault(require("./Banners"));

var CalendarEventList_1 = tslib_1.__importDefault(require("./CalendarEventList"));

var CompetitionDraw_1 = tslib_1.__importDefault(require("./CompetitionDraw"));

var CompetitionStanding_1 = tslib_1.__importDefault(require("./CompetitionStanding"));

var DangerousSource_1 = tslib_1.__importDefault(require("./DangerousSource"));

var Document_1 = tslib_1.__importDefault(require("./Document"));

var EntityReference_1 = tslib_1.__importDefault(require("./EntityReference"));

var External_1 = tslib_1.__importDefault(require("./External"));

var FAQ_1 = tslib_1.__importDefault(require("./FAQ"));

var FormattedText_1 = tslib_1.__importDefault(require("./FormattedText"));

var Iframe_1 = tslib_1.__importDefault(require("./Iframe"));

var ImageAd_1 = tslib_1.__importDefault(require("./ImageAd"));

var MatchDetail_1 = tslib_1.__importDefault(require("./MatchDetail"));

var MatchesList_1 = tslib_1.__importDefault(require("./MatchesList"));

var MatchOverview_1 = tslib_1.__importDefault(require("./MatchOverview"));

var Multiblock_1 = tslib_1.__importDefault(require("./Multiblock"));

var OrganizationProfilesList_1 = tslib_1.__importDefault(require("./OrganizationProfilesList"));

var Partners_1 = tslib_1.__importDefault(require("./Partners"));

var Persons_1 = tslib_1.__importDefault(require("./Persons"));

var Photo_1 = tslib_1.__importDefault(require("./Photo"));

var PhotoGallery_1 = tslib_1.__importDefault(require("./PhotoGallery"));

var PlayerStats_1 = tslib_1.__importDefault(require("./PlayerStats"));

var PrivateContentBoundary_1 = tslib_1.__importDefault(require("./PrivateContentBoundary"));

var Profile_1 = tslib_1.__importDefault(require("./Profile"));

var ResultsTable_1 = tslib_1.__importDefault(require("./ResultsTable"));

var RotatingArticle_1 = tslib_1.__importDefault(require("./RotatingArticle"));

var SectionList_1 = tslib_1.__importDefault(require("./SectionList"));

var Social_1 = tslib_1.__importDefault(require("./Social"));

var SportRecords_1 = tslib_1.__importDefault(require("./SportRecords"));

var Table_1 = tslib_1.__importDefault(require("./Table"));

var Television_1 = tslib_1.__importDefault(require("./Television"));

var TextBlock_1 = tslib_1.__importDefault(require("./TextBlock"));

var UsersList_1 = tslib_1.__importDefault(require("./UsersList"));

var Video_1 = tslib_1.__importDefault(require("./Video"));

var Voting_1 = tslib_1.__importDefault(require("./Voting"));

exports.WidgetWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: ", ";\n  min-height: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  min-width: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  clear: both;\n"], ["\n  margin-bottom: ", ";\n  min-height: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  min-width: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  clear: both;\n"])), function (_a) {
  var theme = _a.theme,
      hasBottomGutter = _a.hasBottomGutter;
  return hasBottomGutter && polished_1.em(theme.grid.gutterWidth * 2.5);
});
var noAppPadding = {
  television: 1,
  video: 1,
  articlelist: 1,
  multiblock: 1
};
var smallWidthWidgets = {
  text: 1,
  document: 1,
  sectionlist: 1
};
var mediumWidthWidgets = {
  actsection: 1,
  externalArticle: 1,
  imagead: 1,
  livestream: 1,
  photo: 1,
  photogallery: 1,
  sportnetvideo: 1,
  table: 1,
  voting: 1,
  matchesList: 1,
  youtube: 1,
  matchOverview: 1,
  resultsTable: 1
};

function getMaxWidth(widget, theme) {
  if (widget.type === 'photo' && widget.fullscreen) {
    return 0;
  }

  return getProp_1["default"](theme, ['app', 'maxWidth'], 1200);
}

exports.getMaxWidth = getMaxWidth;

function getHasAppPadding(widget) {
  if (widget.type === 'photo' && widget.fullscreen) {
    return false;
  }

  return true;
}

exports.getHasAppPadding = getHasAppPadding;

function getHasBottomGutter(widget) {
  return !['text', 'textBlock'].includes(widget.type);
}

exports.getHasBottomGutter = getHasBottomGutter; // @TODO prerobit na mapu

var GenericWidget = function (_a) {
  var widget = _a.widget,
      renderLink = _a.renderLink,
      renderEmpty = _a.renderEmpty,
      override = _a.override,
      theme = _a.theme;

  function render() {
    switch (widget.type) {
      case 'text':
        return react_1["default"].createElement(FormattedText_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'articlelist':
        return react_1["default"].createElement(ArticleList_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty,
          override: override
        });

      case 'entityReference':
        return react_1["default"].createElement(EntityReference_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty,
          override: override
        });

      case 'actsection':
        return react_1["default"].createElement(Actsection_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'calendarEventList':
        return react_1["default"].createElement(CalendarEventList_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'sectionlist':
        return react_1["default"].createElement(SectionList_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'dangerousSource':
        return react_1["default"].createElement(DangerousSource_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'photo':
        return react_1["default"].createElement(Photo_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'photogallery':
        return react_1["default"].createElement(PhotoGallery_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'table':
        return react_1["default"].createElement(Table_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'iframe':
        return react_1["default"].createElement(Iframe_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'video':
        return react_1["default"].createElement(Video_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'sportnetvideo':
      case 'livestream':
      case 'youtube':
        return react_1["default"].createElement(Video_1["default"], {
          data: {
            type: 'video',
            url: widget.uri
          },
          renderEmpty: renderEmpty
        });

      case 'resultsTable':
        return react_1["default"].createElement(ResultsTable_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'imagead':
        return react_1["default"].createElement(ImageAd_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'multiblock':
        return react_1["default"].createElement(Multiblock_1["default"], {
          data: widget,
          renderLink: renderLink,
          renderEmpty: renderEmpty
        });

      case 'rotatingArticle':
        return react_1["default"].createElement(RotatingArticle_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'social':
        return react_1["default"].createElement(Social_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'voting':
        return react_1["default"].createElement(Voting_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'partners':
        return react_1["default"].createElement(Partners_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'persons':
        return react_1["default"].createElement(Persons_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'faq':
        return react_1["default"].createElement(FAQ_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'document':
        return react_1["default"].createElement(Document_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'externalArticle':
        return react_1["default"].createElement(External_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'television':
        return react_1["default"].createElement(Television_1["default"], {
          data: widget,
          renderLink: renderLink
        });

      case 'sportRecords':
        return react_1["default"].createElement(SportRecords_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'matchesList':
        return react_1["default"].createElement(MatchesList_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'competitionDraw':
        return react_1["default"].createElement(CompetitionDraw_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'competitionStanding':
        return react_1["default"].createElement(CompetitionStanding_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'matchDetail':
        return react_1["default"].createElement(MatchDetail_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'matchOverview':
        return react_1["default"].createElement(MatchOverview_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'playerStats':
        return react_1["default"].createElement(PlayerStats_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'usersList':
        return react_1["default"].createElement(UsersList_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'organizationProfilesList':
        return react_1["default"].createElement(OrganizationProfilesList_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'privateContentBoundary':
        return react_1["default"].createElement(PrivateContentBoundary_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'banners':
        return react_1["default"].createElement(Banners_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'textBlock':
        return react_1["default"].createElement(TextBlock_1["default"], {
          data: widget,
          renderEmpty: renderEmpty
        });

      case 'profile':
        return react_1["default"].createElement(Profile_1["default"], {
          data: widget,
          renderEmpty: renderEmpty,
          renderLink: renderLink
        });

      default:
        return null;
    }
  }

  var content = render();

  if (!content) {
    return null;
  }

  if (widget.type === 'textBlock' || widget.type === 'text') {
    return content;
  }

  return react_1["default"].createElement(exports.WidgetWrapper, {
    className: "content-widget",
    maxWidth: getMaxWidth(widget, theme),
    hasAppPadding: getHasAppPadding(widget),
    hasBottomGutter: getHasBottomGutter(widget)
  }, content);
};

exports["default"] = styled_components_1.withTheme(GenericWidget);
var templateObject_1;